import { sportsIconMap } from '@/utils/constants';

const formatEventDateTime = (startTime?: string) => {
  if (!startTime) return '';
  const date = new Date(startTime);
  if (isNaN(date.getTime())) return '';
  const datePart = date.toLocaleDateString('en-GB');
  const timePart = date.toLocaleTimeString('en-GB', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${datePart} ${timePart}`;
};

type Props = {
  name: string;
  sport: string;
  startTime?: string;
  onClick: () => void;
};

const PopularEventCard = ({ name, sport, startTime, onClick }: Props) => (
  <div
    className="cursor-pointer bg-event-card-bg rounded flex items-center gap-2 px-2 py-1 h-full"
    onClick={onClick}
  >
    <div className="flex items-center gap-2 min-w-0 flex-1 animate-pulse-full">
      <span className="text-white shrink-0 rounded-full bg-surface p-1 flex items-center justify-center">
        <img className="size-4" src={sportsIconMap[sport] ?? ''} />
      </span>

      <div className="min-w-0 flex-1">
        <span className="block text-white text-[13px] leading-[16px] truncate font-bold">
          {name}
        </span>
        {startTime && (
          <span className="inline-block mt-[3px] rounded-full bg-event-card-pill text-white text-[10px] leading-none px-2 py-[3px]">
            {formatEventDateTime(startTime)}
          </span>
        )}
      </div>
    </div>
  </div>
);

export default PopularEventCard;
